import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.hx{min-height:100vh;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.dc{padding:2rem;}.ssr-plugin'
import '.av{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="d e r ad hx t dc av"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
